(() => {
  const elementName = 'slib-comparison-slider';

  if (customElements.get(elementName)) {
    return;
  }

  class SlibComparisonSlider extends HTMLElement {
    constructor() {
      super();
      this.handleChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.sliderOverlay = this.querySelector('.comparison-slider__overlay');
      this.sliderLine = this.querySelector('.comparison-slider__line');
      this.sliderInput = this.querySelector('.comparison-slider__input');

      if (!this.sliderOverlay || !this.sliderLine || !this.sliderInput) {
        return;
      }

      this.sliderInput.addEventListener('input', this.handleChange);
      this.sliderInput.addEventListener('change', this.handleChange);
      this.setPosition(this.sliderInput.value || this.dataset.initialPosition || 50);
    }

    disconnectedCallback() {
      if (!this.sliderInput) {
        return;
      }

      this.sliderInput.removeEventListener('input', this.handleChange);
      this.sliderInput.removeEventListener('change', this.handleChange);
    }

    handleChange(event) {
      this.setPosition(event.target.value);
    }

    setPosition(value) {
      const numericValue = Number.parseFloat(value);
      const clampedValue = Number.isFinite(numericValue)
        ? Math.min(100, Math.max(0, numericValue))
        : 50;
      const percentage = `${clampedValue}%`;

      this.style.setProperty('--slib-comparison-position', percentage);
      this.sliderOverlay.style.width = percentage;
      this.sliderLine.style.left = percentage;
      this.sliderInput.value = String(clampedValue);
      this.sliderInput.setAttribute('aria-valuetext', `${Math.round(clampedValue)}%`);
    }
  }

  customElements.define(elementName, SlibComparisonSlider);
})();
